import { MenuItem, TextField, InputAdornment, Divider, Box } from "@material-ui/core";
import { Search } from "@material-ui/icons";
import useStyles from "../../styles";
import { useTranslation } from "react-i18next";

interface ISearchMenuItemProps {
	options: Array<any>;
	searchText: string;
	setSearchText: (text: string) => void;
}

export const SEARCH_THRESHOLD = 10;

function SearchMenuItem(props: ISearchMenuItemProps) {
	const classes = useStyles();
	const { t } = useTranslation();
	const showSearch = props.options.length > SEARCH_THRESHOLD;

	return showSearch ? (
		<Box position={"sticky"} top={0} zIndex={2} bgcolor={"white"}>
			<MenuItem disableRipple disableTouchRipple className={classes.menuItemSearch}>
				<TextField
					variant="outlined"
					size="small"
					placeholder={t("search")}
					value={props.searchText}
					onChange={(e) => props.setSearchText(e.target.value)}
					onKeyDown={(e) => {
						// Prevent MenuList from handling typing
						e.stopPropagation();
					}}
					InputProps={{
						style: { padding: "0px" },
						startAdornment: (
							<InputAdornment position="start">
								<Search color="primary" style={{ marginBottom: "10.5px" }} />
							</InputAdornment>
						),
					}}
					className={classes.searchInput}
				/>
			</MenuItem>
			<Divider />
		</Box>
	) : (
		<></>
	);
}

export default SearchMenuItem;
